import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_right_circle",
  "use": "icon-icon_right_circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_right_circle\"><defs><style></style></defs><path d=\"M512 71.68A440.32 440.32 0 1 1 71.68 512 440.73 440.73 0 0 1 512 71.68m0-51.2A491.52 491.52 0 1 0 1003.52 512 491.52 491.52 0 0 0 512 20.48z\" /><path d=\"M435.2 719.462a25.6 25.6 0 0 1-18.022-7.577l-209.92-209.92a25.6 25.6 0 0 1 36.25-36.25L435.2 657.408l345.498-345.293a25.6 25.6 0 0 1 36.044 36.045l-363.52 363.725a25.6 25.6 0 0 1-18.022 7.577z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol